import { useEffect, useState, useContext } from 'react';
import { useDocumentLinks } from '@sentara-health/sentara-api-hooks-core';
import { useTranslation } from 'react-i18next';
import { errorhandler } from 'common';
import {
  Headings,
  ContactInfo,
  Loader,
  Paragraph,
  ExternalLinkIcon,
  Button,
  FileIcon
} from '@sentara-health/optimahealth_web';
import { GlobalContext } from 'context';


const FormAndDocument = () => {
  const { DocumentLinksType } =
    useDocumentLinks(); /* Document Links type API call to get document link */
  const [documentLink, setDocumentLink] = useState<any>(); /* set api result data */
  useDocumentLinks();
  const [loading, setLoading] = useState(false);
  /* Document Links type API call to get document link */
  const { t } = useTranslation(); /* To translate for internationalization */

  const [phone, setPhone] =
    useState<any>(); /* set service number in Phone from context */
  /* call to documentlink API and get service number from context */

  const {
    serviceNumber
  } = useContext(GlobalContext);

  async function asyncCall() {
    const result = await DocumentLinksType();
    if (result?.data !== null) {
      setDocumentLink(result?.data);
    } else if (result?.errorCode) {
      errorhandler(result?.errorCode);
    }
    setLoading(false);
    setPhone(JSON.parse(serviceNumber ?? '{}'));
  }

  useEffect(() => {
    (async () => {
      setLoading(true);
      await asyncCall();
    })();
  }, []);

  return (
    <>
      {loading && <Loader />}
      <Headings
        level={1}
        text={t('common.formsDocuments')}
        variant="semiBold"
        dataTestId="formsDocumentsHeader"
      />
      {documentLink?.length > 0 &&
        documentLink?.map((item: { link: any; name: any }, index: number) => {
          const isLastLink = index === documentLink.length - 1;

          return (
            <Button
              key={item.link}
              dataTestId={`formsAndDocsLink_${index}`}
              onClick={() => {
                window.open(item.link, '_blank'); // Open SSO URL in a new tab
              }}
              className="py-4 border-bottom rounded-0 w-100 align-items-start"
              iconLeft={!isLastLink && <FileIcon className="mt-1" />}
              iconRight={isLastLink && <ExternalLinkIcon />}
              variant="link_btn"
              iconStroke="none"
            >
              {item.name}
            </Button>
          );
        })}
      {phone?.data?.benefitPhone1800 && (
        <div className="pt-3 pb-4">
          <Paragraph text={
            <>
              {t('common.questions')}{' '}
              <ContactInfo
                phoneData={{
                  phone1800: phone?.data?.benefitPhone1800,
                  phoneLocal: phone?.data?.benefitPhoneLocal,
                }}
              /></>} variant="regular" data-testid="contactInfo" />

        </div>
      )}
    </>
  );
};
export default FormAndDocument;
